<div class="accountEditShare">
  <pp-account-user-modal-shares-list-share-user
    [ppUserId]="share.userId"
  ></pp-account-user-modal-shares-list-share-user>
  <pp-account-user-modal-shares-list-share-access
    [(ppShare)]="share"
    (ppShareChange)="updateShare()"
  ></pp-account-user-modal-shares-list-share-access>
  <pp-account-user-modal-shares-list-share-accessible-tags
    [(ppShare)]="share"
    (ppShareChange)="updateShare()"
    [ppWorkspaceId]="share.workspaceId"
    [ppDisabled]="isDisabledForAdmin"
  ></pp-account-user-modal-shares-list-share-accessible-tags>
  <pp-account-user-modal-shares-list-share-tags
    [(ppShare)]="share"
    (ppTagsPermissionsChange)="updateShare()"
    [ppDisabled]="isDisabledForAdmin"
    [ppShareOption]="share.shareOption"
  ></pp-account-user-modal-shares-list-share-tags>
  <pp-account-user-modal-shares-list-share-activity
    [(ppShare)]="share"
    [ppShareOption]="share.shareOption"
    (ppActivityPermissionsChange)="updateShare()"
    [ppDisabled]="isDisabledForAdmin"
  ></pp-account-user-modal-shares-list-share-activity>
  <pp-account-user-modal-shares-list-share-exports
    [(ppShare)]="share"
    (ppShareChange)="updateShare()"
    [ppDisabled]="isDisabledForAdmin"
  ></pp-account-user-modal-shares-list-share-exports>
  <pp-account-user-modal-shares-list-share-flags
    data-testid="flags-share"
    [(ppShare)]="share"
    (ppShareChange)="updateShare()"
    [ppDisabled]="isDisabledForAdminAndLimited"
  ></pp-account-user-modal-shares-list-share-flags>

  @if (relatedPointsFlagEnabled) {
    <pp-account-user-modal-shares-list-share-relationships
      data-testid="relationships-share"
      [(ppShare)]="share"
      (ppShareChange)="updateShare()"
      [ppDisabled]="isDisabledForAdminAndLimited"
    ></pp-account-user-modal-shares-list-share-relationships>
  }

  <pp-account-user-modal-shares-list-share-comments
    [(ppShare)]="share"
    (ppCommentPermissionsChange)="updateShare()"
    [ppDisabled]="isDisabledForAdmin"
  ></pp-account-user-modal-shares-list-share-comments>
  <pp-account-user-modal-shares-list-share-custom-fields
    (ppEditCustomFields)="showCustomFieldsTable()"
    [ppUserRole]="share.shareOption"
    [ppDisabledByCustomFields]="share.advancedAccessLevels.customFields.length === 0"
  ></pp-account-user-modal-shares-list-share-custom-fields>
</div>
